import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=1e53b8ab&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=1e53b8ab&scoped=true&lang=css&"
import style1 from "./Error404.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53b8ab",
  null
  
)

export default component.exports